export const getRequiredDepthByProductTypeAndCellDesign = (
  productType: string,
  cellDesign: string,
  driveControl: string,
) => {
  if (productType === '' || cellDesign === '') return [];

  const driveControlStripped = driveControl.replace('Drive Control: ', '');

  const honeycombStandardDepths = [
    {
      driveControl: 'Corded',
      cellDesign: 'Single Cell 25mm',
      depth: '34mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Corded',
      cellDesign: 'Single Cell 45mm',
      depth: '53mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Corded',
      cellDesign: 'Double Cell 45mm',
      depth: '53mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Cordloop',
      cellDesign: 'Single Cell 25mm',
      depth: '57mm',
      deductions: '10mm',
    },
    {
      driveControl: 'Cordloop',
      cellDesign: 'Single Cell 45mm',
      depth: '57mm',
      deductions: '10mm',
    },
    {
      driveControl: 'Cordloop',
      cellDesign: 'Double Cell 45mm',
      depth: '57mm',
      deductions: '10mm',
    },
    {
      driveControl: 'Cordless',
      cellDesign: 'Single Cell 25mm',
      depth: '46mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Cordless',
      cellDesign: 'Single Cell 45mm',
      depth: '50mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Cordless',
      cellDesign: 'Double Cell 45mm',
      depth: '50mm',
      deductions: '6mm',
    },
  ];

  const honeycombDualViewDepths = [
    {
      driveControl: 'Corded',
      cellDesign: 'Single Cell 25mm',
      depth: '34mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Corded',
      cellDesign: 'Single Cell 45mm',
      depth: '53mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Corded',
      cellDesign: 'Double Cell 45mm',
      depth: '53mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Cordloop',
      cellDesign: 'Single Cell 25mm',
      depth: '57mm',
      deductions: '10mm',
    },
    {
      driveControl: 'Cordloop',
      cellDesign: 'Single Cell 45mm',
      depth: '57mm',
      deductions: '10mm',
    },
    {
      driveControl: 'Cordloop',
      cellDesign: 'Double Cell 45mm',
      depth: '57mm',
      deductions: '10mm',
    },
    {
      driveControl: 'Cordless',
      cellDesign: 'Single Cell 25mm',
      depth: '46mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Cordless',
      cellDesign: 'Single Cell 45mm',
      depth: '50mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Cordless',
      cellDesign: 'Double Cell 45mm',
      depth: '50mm',
      deductions: '6mm',
    },
  ];

  const honeycombDayNightDepths = [
    {
      driveControl: 'Corded',
      cellDesign: 'Single Cell 25mm',
      depth: '34mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Corded',
      cellDesign: 'Single Cell 45mm',
      depth: '53mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Corded',
      cellDesign: 'Double Cell 45mm',
      depth: '53mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Cordloop',
      cellDesign: 'Single Cell 25mm',
      depth: '57mm',
      deductions: '10mm',
    },
    {
      driveControl: 'Cordloop',
      cellDesign: 'Single Cell 45mm',
      depth: '57mm',
      deductions: '10mm',
    },
    {
      driveControl: 'Cordloop',
      cellDesign: 'Double Cell 45mm',
      depth: '57mm',
      deductions: '10mm',
    },
    {
      driveControl: 'Cordless',
      cellDesign: 'Single Cell 25mm',
      depth: '46mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Cordless',
      cellDesign: 'Single Cell 45mm',
      depth: '50mm',
      deductions: '6mm',
    },
    {
      driveControl: 'Cordless',
      cellDesign: 'Double Cell 45mm',
      depth: '50mm',
      deductions: '6mm',
    },
  ];

  const honeycombSmartfitDepths = [
    {
      driveControl: '',
      cellDesign: 'Single Cell 25mm',
      depth: '32mm',
      deductions: '6mm',
    },
    {
      driveControl: '',
      cellDesign: 'Single Cell 45mm',
      depth: '47mm',
      deductions: '6mm',
    },
    {
      driveControl: '',
      cellDesign: 'Double Cell 45mm',
      depth: '47mm',
      deductions: '6mm',
    },
  ];

  const honeycombSkylightDepths = [
    {
      driveControl: '',
      cellDesign: 'Single Cell 25mm',
      depth: '32mm',
      deductions: '6mm',
    },
  ];

  const honeycombVertical = [
    {
      driveControl: '',
      cellDesign: 'Single Cell 45mm',
      depth: '84mm',
      deductions: '6mm',
    },
  ];

  if (productType.includes('Honeycomb Standard')) {
    if (driveControl === '') return [];
    return honeycombStandardDepths
      .filter(options => options.driveControl === driveControlStripped)
      .filter(option => option.cellDesign === cellDesign);
  } else if (productType.includes('Honeycomb Smartfit')) {
    return honeycombSmartfitDepths.filter(
      option => option.cellDesign === cellDesign,
    );
  } else if (productType.includes('Honeycomb Skylight')) {
    return honeycombSkylightDepths.filter(
      option => option.cellDesign === cellDesign,
    );
  } else if (productType.includes('Honeycomb Dual View')) {
    if (driveControl === '') return [];
    return honeycombDualViewDepths
      .filter(options => options.driveControl === driveControlStripped)
      .filter(option => option.cellDesign === cellDesign);
  } else if (productType.includes('Honeycomb Day/Night')) {
    if (driveControl === '') return [];
    return honeycombDayNightDepths
      .filter(options => options.driveControl === driveControlStripped)
      .filter(option => option.cellDesign === cellDesign);
  } else if (productType.includes('Honeycomb Vertical')) {
    return honeycombVertical.filter(
      option => option.cellDesign === cellDesign,
    );
  }
};
